import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from '@/App.vue'

// 引入路由
import router from "@/router.js"    // import router 的router 一定要小写， 不要写成Router, 否则报 can't match的报错

Vue.use(ElementUI)

Vue.config.productionTip = false

//创建路由
// const router = new VueRouter({
//     routes:Routes,
//     mode:"history",//去掉#
// })

const app = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')